export const SPECIESLIST_REQUEST = "SPECIESLIST_REQUEST";
export const SPECIESLIST_SUCCESS = "SPECIESLIST_SUCCESS";
export const SPECIESLIST_ERROR = "SPECIESLIST_ERROR";
export const SPECIESLIST_params = {
    key: process.env.VUE_APP_API_KEY,
    connector: 'ILTTripGroupedBottles',
    size: 1000,
    filter: []
};